import { useState } from 'react';
import { resetPassword, formatApiError } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function ForgotPasswordPage({ onBackToLogin }) {
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [groupSecret, setGroupSecret] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: '', message: '' });
    setLoading(true);
    try {
      await resetPassword({ email, new_password: newPassword, group_secret: groupSecret });
      setStatus({ type: 'success', message: 'Password reset successfully. You can now login.' });
      setTimeout(() => onBackToLogin(), 2000);
    } catch (err) {
      if (err.response?.data?.detail) {
        setStatus({ type: 'error', message: formatApiError(err.response.data.detail) });
      } else {
        setStatus({ type: 'error', message: 'Failed to reset password. Please check your details.' });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-sm animate-fade-in">
        <div className="mb-8">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground mb-2">Reset</p>
          <h1 className="text-3xl font-black tracking-tighter leading-none font-['Outfit']">
            Password
          </h1>
          <p className="text-sm text-muted-foreground mt-3">Enter your group secret to reset.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          {status.message && (
            <div className={`text-sm p-3 rounded-sm border ${status.type === 'error' ? 'bg-destructive/10 text-destructive border-destructive/20' : 'bg-green-500/10 text-green-600 border-green-500/20'}`}>
              {status.message}
            </div>
          )}
          <div className="space-y-2">
            <Label htmlFor="reset-email" className="text-xs font-bold uppercase tracking-[0.15em]">Email</Label>
            <Input id="reset-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-sm h-11 border bg-background" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="reset-password" className="text-xs font-bold uppercase tracking-[0.15em]">New Password</Label>
            <Input id="reset-password" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required className="rounded-sm h-11 border bg-background" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="group-secret" className="text-xs font-bold uppercase tracking-[0.15em]">Group Secret PIN</Label>
            <Input id="group-secret" type="password" value={groupSecret} onChange={(e) => setGroupSecret(e.target.value)} required className="rounded-sm h-11 border bg-background" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 rounded-sm font-semibold text-sm tracking-wide">
            {loading ? 'Resetting...' : 'Reset Password'}
          </Button>
        </form>
        <p className="text-sm text-muted-foreground mt-6 text-center">
          Remembered it?{' '}
          <button onClick={onBackToLogin} className="text-primary font-semibold hover:underline underline-offset-4">
            Back to login
          </button>
        </p>
      </div>
    </div>
  );
}
